import type { ReactElement } from 'react'
import styles from './SecondaryButton.module.css'

export interface SecondaryButtonProps {
  /** Visible label, e.g. "Route Details" / "Retry". */
  readonly label: string
  /** Tap handler. Optional — no-op default keeps emit-only call sites safe. */
  readonly onClick?: () => void
  /** Stable a11y / test id (e.g. `route-details-button`, `route-empty-retry`). */
  readonly testId: string
}

/**
 * Shared secondary action button (Figma spec §1.10 — same atom as
 * StationCard V2's SecondaryButton). `bg/secondary` fill, `padding
 * 24h / 20v`, `r 32`, label `regularPx16` / `text/primary`. In
 * RouteCard it renders `flex 1 0`, h 64 as "Route Details" (Results)
 * and "Retry" (Empty / Error).
 *
 * Only the `label`, `testId`, and the emitted output differ across the
 * three call sites; the visual atom is identical.
 */
export function SecondaryButton({ label, onClick, testId }: SecondaryButtonProps): ReactElement {
  return (
    <button type="button" className={styles.button} data-testid={testId} onClick={onClick}>
      {label}
    </button>
  )
}
